import {fetchUserProfile, doLogUser } from '../firebase/db'

import {doListenMessagingInbox} from '../firebase/database/handleMessaging'
import {listenMyConfirmedEvents} from '../firebase/database/handleEvents'
import {auth } from '../firebase/firebase'
//import {getMessagingToken} from '../actions/subscriptions'
//import { APPLY_NOTIFICATION_TOKEN } from '../constants/actionTypes'
//import 'firebase/auth'
import { dispatch } from '../store'
import { onFetchUser} from '../actions/user'
import { isIOS } from 'react-device-detect'
//import initMessaging  from '../firebase/initMessaging'

 

export const watchAuth = async () => {
  await auth.onAuthStateChanged(async function(user) {
    // checkSubscriptionState(userId)
    if (!user) {
      console.info('No User logged in')
      dispatch({type: 'AUTH_USER_SET', payload: false})
      await onFetchUser(null)
      
      return 'no user auth'
    }
    console.info('user LoggedIn')
      const userId = user.uid
      const userProfile = await fetchUserProfile(userId)
      dispatch({type: 'AUTH_USER_SET', payload: user})
      await onFetchUser(userProfile)
      await doLogUser(userId)
      await listenMyConfirmedEvents(userId)
      await doListenMessagingInbox(userId)
   
      //if(isIOS) return 'IOs detected'
      //console.log('----IOs danach---initMeesaging-comt')
      if(!isIOS) {
        //const initMessaging = () => import(`../firebase/initMessaging`)
        //return initMessaging()
      }
    })
    return 'done'

}
//const dispatch = store.dispatch
/*
export async function initApp  (props)  {
  
  auth.onAuthStateChanged(async function(user) {
    // checkSubscriptionState(userId)
    if (!user) {
      console.info('No User logged in')
      onFetchUser(null)
      return 
    }
    console.info('authStatus changed')
      const userId = user.uid
      const userProfile = await fetchUserProfile(userId)
      await onFetchUser(userProfile)
      await doLogUser(userId)
      await listenMyConfirmedEvents(userId)
      await doListenMessagingInbox(userId)
      console.log(isIOS)
   
      //if(isIOS) return 'IOs detected'
      //console.log('----IOs danach---initMeesaging-comt')
      if(!isIOS) {
        //const initMessaging = () => import(`../firebase/initMessaging`)
        return initMessaging()
      }

     //return initMessaging()
      
  })
 
  return sendPromise('resolved')
}

const sendPromise = type => {
  return Promise.resolve(type)}


export default initApp

*/


// WEBPACK FOOTER //
// ./src/appInit/index.js